<div id="modal-kpiConfig" class="mt-4 modal fade modal-window kpiConfigComponent" tabindex="-1" role="dialog" aria-hidden="true">
  <div class="modal-dialog" role="document">
    <div class="modal-content">
      
      <div class="modal-body">
            <h6 class="title"> Select metrics to display</h6>
        <span>Select the metrics you would like to display on your engagements dashboard.</span>
          <br><br>
          <div class="masonry-grid-kpiPopup" *ngIf="userKpiMasterViewModel.length > 0">
            <div class="col-md-6 custom-control custom-checkbox pl-4 mb-2"
              *ngFor="let userKpi of userKpiMasterViewModel">
              <input class="custom-control-input" type='checkbox'
                id="{{userKpi.mappingId}}" value='{{userKpi.canShowInDashboard}}'
                [(ngModel)]='userKpi.canShowInDashboard'>
              <span *ngIf="userKpi.canShowInDashboard"></span>
              <span class="custom-control-label">
                {{userKpi.displayText}}</span> &ndash;
              <span><span innerHtml="{{userKpi.descriptionText}}"></span></span>
            </div>
          </div>

      </div>
      <div class="modal-footer">
        <div class="d-block pr-3 pt-0 justify-content-center mt-0 mb-3">
          <div class="text-right" *ngIf="showErrorMEssage==true">
            <span id="kpi-config-update" class="text-right pt-1 error-color">Configuration
              update failed.</span>
          </div>
          <div class="mt-2">
          <button type="button" class="SecondaryButton text-center w-130" data-dismiss="modal"
            aria-hidden="true" (click)="cancelClicked($event)">
            <span>
              <img class="d-inline-block mr-1 align-top" src="../../../assets/images/EDP/Engagement/cancel-24px.svg"
                alt="Cancel" />
            </span>
            <span id="manageTeam-close-cancel-cap" class="d-inline-block align-middle"> Cancel</span>
          </button>
          <button 
              class="PrimaryButton text-center ml-3 w-130" type="button"
              (click)="okClicked()">
              <span>
                <img class="d-inline-block mr-1  align-top"
                  src="../../../assets/images/EDP/Engagement/ok-24px.svg" alt="ok" />
              </span>
              <span class="d-inline-block align-middle"> OK </span>
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>